{
  "RESET_PASSWORD": {
    "TITLE": "Reset kata sandi",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Harap masukkan email Anda.",
      "ERROR": "Harap masukkan email yang valid."
    },
    "API": {
      "SUCCESS_MESSAGE": "Link pengaturan ulang kata sandi telah dikirim ke email Anda.",
      "ERROR_MESSAGE": "Tidak dapat terhubung ke Server Woot, Silahkan coba lagi nanti"
    },
    "SUBMIT": "Kirim"
  }
}
